import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register the plugin to prevent treeshaking removing it.
gsap.registerPlugin(ScrollTrigger);

function initTimelines(layouts) {
  layouts.forEach((layout) => {
    const images = gsap.utils.toArray('.cross-scrolling-image', layout);

    images.forEach((image) => {
      gsap.fromTo(
        image,
        {
          x: image.classList.contains('cross-scrolling-image--left') ? '0%' : '0%',
        },
        {
          x: image.classList.contains('cross-scrolling-image--left') ? '-50%' : '50%',
          ease: 'none',
          scrollTrigger: {
            trigger: layout,
            start: 'top bottom',
            end: 'bottom top',
            invalidateOnRefresh: true,
            scrub: 0.3,
          },
        },
      );
    });
  });
}

function init() {
  const layouts = gsap.utils.toArray('.layout--cross-scrolling-images');

  initTimelines(layouts);
}

jQuery(init);
